import React from 'react';

const Toolbar = ({ onSave, onLoad, onClear, onExport }) => {
  const handleLoad = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    input.onchange = (e) => {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (ev) => {
        try {
          const data = JSON.parse(ev.target.result);
          onLoad(data);
        } catch {
          alert('Invalid JSON file');
        }
      };
      reader.readAsText(file);
    };
    input.click();
  };

  return (
    <div className="toolbar">
      <div className="toolbar-title">NRG Asset Canvas</div>
      <div className="toolbar-actions">
        <button className="toolbar-btn" onClick={onSave} title="Save layout (Ctrl+S)">
          💾 Save
        </button>
        <button className="toolbar-btn" onClick={handleLoad} title="Load layout">
          📂 Load
        </button>
        <button className="toolbar-btn" onClick={onExport} title="Export as JSON">
          📤 Export
        </button>
        <button className="toolbar-btn toolbar-btn-danger" onClick={onClear} title="Clear canvas">
          🗑️ Clear
        </button>
      </div>
    </div>
  );
};

export default Toolbar;
